
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DataTableHeader } from 'vuetify';
import { CertificateInterface, CertificatesRepositoryInterface } from '@/services/SSL/interfaces';
import ViewCertificateDialog from '@/components/dialogs/ssl/ViewCertificateDialog.vue';
import DeleteCertificateDialog from '@/components/dialogs/ssl/DeleteCertificateDialog.vue';
import CertificateLogsDialog from '@/components/dialogs/ssl/CertificateLogsDialog.vue';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    ViewCertificateDialog,
    DeleteCertificateDialog,
    CertificateLogsDialog,
  },
  inject: [
    'certificateRepository',
  ],
})
export default class AllCertificates extends Vue {
  private loading: boolean = false;
  private search: string = '';
  private certificates: CertificateInterface[] = [];
  private headers: DataTableHeader[] = [
    { text: 'Domain', value: 'domain' },
    { text: 'Type', value: 'type' },
    { text: 'CreateDate', value: 'createDate' },
    { text: 'Issued At', value: 'issuedAt' },
    { text: 'Expires At', value: 'expiresAt' },
    { text: 'Auto Renew', value: 'autoRenew' },
    { text: 'Vhost Aliases', value: 'vhostAliases' },
    { text: 'CDN Sync', value: 'ccgSync.status' },
    { text: 'status', value: 'status' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private certificateDialog: string = '';
  private certificateForDialog: CertificateInterface | false = false;

  private deleteCertificateDialog: string = '';
  private certificateForDeleteDialog: CertificateInterface | false = false;

  private certificateLogsDialog: string = '';
  private certificateForLogsDialog: CertificateInterface | false = false;

  private readonly certificateRepository!: CertificatesRepositoryInterface;

  private newCertificate(): void {
    this.$router.push({ name: 'certificate_create' });
  }

  private async searchCertificate(): Promise<void> {
    if (this.search.trim() === '') {
      this.certificates = [];

      return;
    }
    try {
      this.loading = true;
      this.certificates = await this.certificateRepository.searchCertificates(1, this.search);
      this.loading = false;
    } catch (err) {
      this.certificates = [];
      if (err.response.data.statusCode !== 404) {
        this.$errorDialog.show(err.response?.data?.message ? err.response.data.message : err.message);

        return;
      }
    }
  }

  private viewCertificate(certificate: CertificateInterface): void {
    this.certificateDialog = 'view-certificate-dialog';
    this.certificateForDialog = certificate;
  }

  private deleteCertificate(certificate: CertificateInterface): void {
    this.deleteCertificateDialog = 'delete-certificate-dialog';
    this.certificateForDeleteDialog = certificate;
  }

  private async renewCertificate(certificate: CertificateInterface): Promise<void> {
    await this.certificateRepository.renewCertificate(certificate.id);
    await this.searchCertificate();
    const index = this.certificates.findIndex((cert) => cert.id === certificate.id);
    if (index === -1) {
      return;
    }

    this.certificates[index].status = 'deactivated';
  }

  public showLogsDialog(certificate: CertificateInterface): void {
    this.certificateLogsDialog = 'certificate-logs-dialog';
    this.certificateForLogsDialog = certificate;
  }

  public async recreate(certificate: CertificateInterface): Promise<void> {
    await this.$router.push({ name: 'certificate_create', query: { id: certificate.id } });
  }
}
